<template>
  <div style="width: 18vw; padding: 0.5vw 0.5vw">
    <div style="margin: 0.5vw 1vw">
      <div class="image-container">
        <img
          width="100%"
          style="height: 10.5vw"
          :src="record.pic ? record.pic : img"
          alt=""
          class="img1"
        />

        <div class="icon">
          <div>
            <div
              class="icon-div1"
              v-for="(item, index) in record.tags"
              :key="index"
              :style="{ background: item.color, color: 'white' }"
            >
              {{ item.tag }}
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          font-size: 0.75vw !important;
          font-weight: 700 !important;
          margin-top: 1vw;
          margin-left: 0.4vw;
        "
      >
        <span style="color: #0067b3">{{ record.code }}</span>
        {{ record.model ? record.model : "" }}
        {{ record.brand ? record.brand : "" }}
      </div>

      <div
        style="display: flex; justify-content: space-around; margin-top: 1vw"
      >
        <div class="div_align">
          <img src="../img/rili.png" alt="" style="width: 1.4vw" />
          <div>{{ record.factoryDate }}</div>
        </div>
        <div class="div_align">
          <img
            style="width: 1.4vw"
            src="../img/shandian.svg"
            alt=""
            class="svg1"
          />
          <div>{{ record.动力方式 }}</div>
        </div>
        <div class="div_align">
          <img style="width: 1.4vw" src="../img/zhongliang.png" alt="" />
          <div>{{ parseStringToNumber(record.载重能力) }}kg</div>
        </div>
        <div class="div_align">
          <img style="width: 1.4vw" src="../img/xiangao.svg" alt="" />
          <div>{{ parseStringToNumber(record.货叉最大升高) }}mm</div>
        </div>
        <div class="div_align">
          <img style="width: 1.4vw" src="../img/shizhong.png" alt="" />
          <div>{{ parseStringToNumber(record.购入时工时) }}h</div>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: space-around;
          padding: 0.75vw 0.25vw;
        "
      >
        <div style="display: flex; justify-content: space-around; flex: 5">
          <div>
            <img
              src="../img/bofang.png"
              alt=""
              style="cursor: pointer; width: 1.4vw"
              @click="playVideo(record.id)"
            />
          </div>

          <div>
            <img
              style="cursor: pointer; width: 1.4vw"
              ref="shoucang"
              :src="
                $store.state.favoriteList.filter((item) => item.id == record.id)
                  .length > 0
                  ? require('../img/yishoucang.png')
                  : require('../img/shoucang.png')
              "
              alt=""
              @click="favourite"
            />
          </div>
          <div>
            <img
              style="cursor: pointer; width: 1.4vw"
              :src="
                $store.state.bijiaoList.filter((item) => item.id == record.id)
                  .length > 0
                  ? require('../img/yibijiao.png')
                  : require('../img/tianping.png')
              "
              alt=""
              @click="compare"
            />
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: right;
            padding-right: 0.75vw;
            flex: 5;
            color: rgb(255, 166, 10);
          "
          v-if="$store.state.userInfo.length > 0"
        >
          {{ $t("forkmodel.登录后查询价格") }}
        </div>
      </div>

      <div style="display: flex">
        <a class="DetailStyle" @click="clickDetail(record.id)">{{
          $t("forkmodel.详情")
        }}</a>
        <a class="InquireStyle" @click="clickQuotation()">{{
          $t("forkmodel.询价")
        }}</a>
        <quotation ref="quotation"></quotation>
      </div>
      <videoModel ref="videoModel"></videoModel>
    </div>
  </div>
</template>

<script>
// import Router from "vue-router";
import quotation from "./quotation.vue";
import { getBucket } from "../utils/util";
import videoModel from "./videoModel.vue";
export default {
  components: { quotation, videoModel },
  props: {
    record: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLogin: 0,
      img: require("../img/wtupian.png"),
      tags: [],
    };
  },
  mounted() {
    // console.log(this.record.pic, "=========this.record.pic");
    this.getImg(this.record.id);
    this.isLogin = Object.keys(this.$store.state.userInfo).length;
  },
  watch: {
    record(newValue, oldValue) {
      this.getImg(newValue.id);
    },
  },
  methods: {
    parseStringToNumber(str) {
      // 使用正则表达式替换掉不需要的字符
      // console.log("str===", str);
      if (!str) {
        return 0;
      }
      if (str == "无") {
        return 0;
      }
      const cleanedStr = str.replace(/[kKgGmMhH ]|无/g, "");

      // 尝试将清理后的字符串转换为数字
      const number = parseFloat(cleanedStr);

      // 检查转换是否成功
      if (isNaN(number)) {
        console.error("字符串无法转换为数字", str);
        return 0;
      }

      return number;
    },
    playVideo(id) {
      // this.$message.success("开始播放");
      this.$refs.videoModel.show({ id: id });
    },
    imgclick() {
      let tags = this.record.tags;
      console.log("tags=====", tags);
      console.log("tags=====", tags[0].tag);
    },
    favourite() {
      let arr = [];
      arr = this.$store.state.favoriteList;
      //alert(this.$store.state.favoriteList);
      if (arr.filter((item) => item.id == this.record.id).length <= 0) {
        arr.push(this.record);
        this.$store.dispatch("setFavoriteMessage", arr);
        localStorage.setItem("favoriteJson", JSON.stringify(arr));
        //this.$refs.shoucang.src = require("../img/bofang.png");
        this.$message.info("收藏成功");
      } else {
        this.$message.info("重复收藏");
      }
    },
    compare() {
      let arr = [];
      arr = this.$store.state.bijiaoList;
      //alert(this.$store.state.favoriteList);
      if (arr.filter((item) => item.id == this.record.id).length <= 0) {
        arr.push(this.record);
        this.$store.dispatch("setbijiaoMessage", arr);
        localStorage.setItem("bijiaoJson", JSON.stringify(arr));
        //this.$refs.shoucang.src = require("../img/bofang.png");
        this.$message.info("加入比较成功");
      } else {
        this.$message.info("重复加入比较");
      }
    },
    getImg(id) {
      getBucket("basic/", id).then((res) => {
        this.$set(this.record, "pic", res[0]);
      });
    },
    async getVideo(id) {
      getBucket("basicVideo/", id).then((res) => {
        this.$set(this.record, "video", res[0]);
      });
    },
    login() {
      this.$router.push({ path: "/Login" });
    },
    clickQuotation() {
      // if (this.isLogin == 0) {
      //   this.login();
      // } else {
      this.$refs.quotation.show({ type: "fork", record: this.record });
      //}
    },
    clickDetail(id) {
      this.$router.push({
        path: "/forkliftDetail",
        query: { id: id },
      });
      if (this.$route.name == "forkliftDetail") {
        window.scrollTo({
          top: 0,
          behavior: "instant", // 可选，设置为 'smooth' 可以平滑滚动
        });
        this.$emit("getID", id);
      }
    },
  },
};
</script>

<style scoped>
.div_align {
  text-align: center;
  font-size: 0.75vw;
}
.image-container {
  position: relative; /* 相对定位，使内部absolute定位的元素相对于此容器定位 */
  display: inline-block; /* 使div像inline-element一样表现，便于内部元素的定位 */
  width: 100%;
}

.image-container img {
  display: block; /* 防止图片下方出现空隙 */
  width: 100%; /* 或其他宽度 */
}

.img1 {
  object-fit: cover; /* 不会变形，但可能裁剪图片 */
}

.image-container .icon {
  position: absolute; /* 绝对定位 */
  top: 0.25vw; /* 定位到图片的顶部 */
  right: 0px; /* 定位到图片的右侧 */
  font-size: 1vw; /* 图标大小 */
  font-size: 0.6vw; /* 标签字体大小 */
}
.icon-div1 {
  display: flex;
  font-size: 0.6vw;
  font-weight: 700;
  color: black;
  justify-content: center;
  align-items: center;
  width: 5vw;
  height: 1.5vw;

  margin-bottom: 0.25vw;
  clip-path: polygon(
    10% 0%,

    100% 0%,
    100% 100%,
    100% 100%,
    10% 100%,
    0% 50%
  );
}
.icon-div2 {
  display: flex;
  font-size: 0.6vw;
  font-weight: 700;
  color: #0067b3;
  justify-content: center;
  align-items: center;
  width: 5vw;
  height: 1.5vw;

  margin-bottom: 0.25vw;
  clip-path: polygon(
    10% 0%,

    100% 0%,
    100% 100%,
    100% 100%,
    10% 100%,
    0% 50%
  );
  background-color: #f3f3f3;
}
.DetailStyle {
  font-weight: 400;
  color: #f3f3f3;
  font-size: 1vw;
  display: flex;
  justify-content: center;
  flex: 5;
  height: 2.5vw;
  background-color: #1890ff;
  align-items: center;
}
.InquireStyle {
  font-weight: 400;
  color: #f3f3f3;
  font-size: 1vw;
  display: flex;
  justify-content: center;
  flex: 5;
  height: 2.5vw;
  background-color: #0067b3;
  align-items: center;
}
</style>
